<template>
  <div class="c-player__subtitles">
    <div v-for="line in lines">
      <p v-dompurify-html="line"></p>
    </div>
  </div>
</template>
<script>
  import { state } from '@/shared/components/player/store';

  export default {
    name: 'UiPlayerSubtitles',
    computed: {
      lines() {
        return state.subtitles;
      },
    },
  };
</script>
